import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = "Page Not Found — NeuraCyb Intelligence";
  }, []);

  return (
    <div className="nf-wrap">
      <div className="nf-glow" aria-hidden="true" />
      <div className="nf-card">
        <div className="nf-code" aria-hidden="true">404</div>
        <h1 className="nf-title">This page went dark.</h1>
        <p className="nf-desc">
          We couldn’t find <code className="nf-code-inline">{pathname}</code>. It might have been
          moved, renamed, or never existed.
        </p>
        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-primary">Go Home</Link>
          <Link to="/articles/latest-news" className="nf-btn nf-ghost">Latest News</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
